export default __webpack_public_path__ + "static/media/ger1.2474be53.JPG";